"use strict";

exports.__esModule = true;
exports.viewModesMap = exports.viewModes = exports.sliderSettings = exports.sliderDirectionMap = exports.filtersType = exports.filtersMap = exports.filtersKeys = void 0;
var _commonMediaQuery = require("@mmc/common-media-query");
var filtersType = exports.filtersType = {
  TEXT: 'text',
  MULTIPLE: 'multiple',
  SINGLE: 'single'
};
var filtersMap = exports.filtersMap = {
  // ZIP_CODE: 'zipCode',
  ZIP_CODE: 'zipCode',
  VEHICLE: 'vehicles'
  // UTM: 'utm_medium',
  // OFFER_TYPE: 'offerTypes',
  // MODEL_YEAR: 'modelYear',
  // REGION: 'region',
};
var filtersKeys = exports.filtersKeys = Object.values(filtersMap);
var viewModesMap = exports.viewModesMap = {
  GRID: 'grid',
  SLIDER: 'slider'
};
var viewModes = exports.viewModes = Object.values(viewModesMap);
var sliderDirectionMap = exports.sliderDirectionMap = {
  PREV: 'prev',
  NEXT: 'next'
};
var sliderSettings = exports.sliderSettings = {
  infinite: false,
  dots: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  touchThreshold: 100,
  responsive: [{
    breakpoint: _commonMediaQuery.BREAKPOINTS.sm.MAX,
    settings: {
      arrows: false,
      slidesToScroll: 2,
      slidesToShow: 2
    }
  }, {
    breakpoint: _commonMediaQuery.BREAKPOINTS.xs.MAX,
    settings: {
      arrows: true,
      slidesToScroll: 1,
      slidesToShow: 1
    }
  }]
};